import { Suspense } from "react";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme";
import { BrowserRouter } from "react-router-dom";
import Routes from "./Routes";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import makeStyles from "@mui/styles/makeStyles";
import { PRI_600 } from "./theme/colors";
import { connect } from "react-redux";
import ModalNotification from "./components/ModalNotification";
import { resetNotif } from "./redux/actions/app";
import FailLottie from "./assets/lottie/failed_loading.json";
import SuccessLottie from "./assets/lottie/success_loading.json";
import { setTokenPasien } from "./redux/actions/firebase";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Lotties from "./components/Lotties";
import LottieHeart from "./assets/lottie/load_heart.json";
import { Stack } from "@mui/material";
// import { onMessageListener, requestPermission } from "./firebase";

// const browserHistory = createBrowserHistory();
const useStyles = makeStyles(() => ({
  backdrop: {
    zIndex: 1305,
    color: "#fff",
  },
}));
const App = (props) => {
  const classes = useStyles();
  const {
    stateLoading,
    stateNotif,
    actResetNotif,
    stateUser,
    actSetTokenPasien,
  } = props;

  // React.useEffect(() => {
  //   let swRegistration = null;

  //   let unsubscribe = null;
  //   const setupFCM = async () => {
  //     try {
  //       // Register the service worker
  //       swRegistration = await navigator.serviceWorker.register(
  //         "/firebase-messaging-sw.js"
  //       );

  //       // Get the token
  //       const token = await requestPermission(swRegistration);
  //       if (token && stateUser) {
  //         actSetTokenPasien({ client_token: token });
  //       }
  //       const messaging = await getMessagingInstance();
  //       unsubscribe = onMessage(messaging, (payload) => {
  //         console.log(payload);
  //         if (document.visibilityState === "visible") {
  //           console.log("📬 Foreground message received:", payload);
  //         } else {
  //           console.log("📭 Message received while app is hidden");
  //         }
  //         toast(payload.notification.title, { type: "info" });
  //       });
  //     } catch (err) {
  //       console.error("SW or FCM setup error:", err);
  //     }
  //   };

  //   setupFCM();

  //   return () => {
  //     if (unsubscribe) unsubscribe(); // Clean up message listener
  //   };
  // }, [stateUser]);

  return (
    <ThemeProvider theme={theme}>
      <ModalNotification
        open={stateNotif.open}
        setOpen={() => actResetNotif()}
        title={stateNotif.title}
        subtitle={stateNotif.subtitle}
        img={stateNotif.type === "error" ? FailLottie : SuccessLottie}
        actAbort={stateNotif.actAbort}
        type="lottie"
      />
      <Backdrop className={classes.backdrop} open={stateLoading}>
        <Stack display="flex" alignItems="center">
          {/* <CircularProgress color="inherit" size="24px" /> */}
          <Lotties file={LottieHeart} loop={true} size={"small"} />

          {/* <CircularProgress
            sx={{
              color: PRI_600 + "!important",
            }}
          /> */}
        </Stack>
      </Backdrop>
      <ToastContainer />
      <BrowserRouter
      // basename="/web"
      >
        <Suspense
          fallback={
            <span
              style={{
                height: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                // position: "absolute",
                // top: "50%",
                // left: "50%",
                // margin: "-25px 0 0 -25px",
              }}
            >
              <Lotties file={LottieHeart} loop={true} size={"small"} />

              {/* <CircularProgress
              // sx={{
              //   color: PRI_600 + "!important",
              // }}
              /> */}
            </span>
          }
        >
          <Routes />
        </Suspense>
      </BrowserRouter>
    </ThemeProvider>
  );
};

const mapStateToProps = (state) => {
  return {
    stateNotif: state.app.notification,
    stateLoading: state.app.loading,
    stateUser: state.auth,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    actResetNotif: () => dispatch(resetNotif()),
    actSetTokenPasien: (body) => dispatch(setTokenPasien(body)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(App);
